import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import { Assessment as QualityIcon } from '@mui/icons-material';

const DataQuality: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <QualityIcon sx={{ fontSize: 40 }} />
          Data Quality Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Monitor and improve data quality across the organization
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: 'center', background: 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)', color: 'white' }}>
            <Typography variant="h3" sx={{ fontWeight: 700, color: 'white' }}>87%</Typography>
            <Typography variant="body1" sx={{ color: 'white' }}>Overall Quality Score</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: 'center', background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)', color: 'white' }}>
            <Typography variant="h3" sx={{ fontWeight: 700, color: 'white' }}>156</Typography>
            <Typography variant="body1" sx={{ color: 'white' }}>Quality Rules</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: 'center', background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)', color: 'white' }}>
            <Typography variant="h3" sx={{ fontWeight: 700, color: 'white' }}>23</Typography>
            <Typography variant="body1" sx={{ color: 'white' }}>Open Issues</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: 'center', background: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)', color: 'white' }}>
            <Typography variant="h3" sx={{ fontWeight: 700, color: 'white' }}>12</Typography>
            <Typography variant="body1" sx={{ color: 'white' }}>Data Domains</Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Data Quality Dashboard Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Quality scorecards, Rule management, Issue tracking, Remediation workflows, Trend analysis.
        </Typography>
      </Paper>
    </Container>
  );
};

export default DataQuality;
